export default {
  nav: {
    dashboard: '대시보드',
    teams: '팀 및 로스터',
    masterManagement: '리그 및 선수 마스터 관리',
    videoAnalytics: '비디오 & AI 분석',
    training: '스킬 & 바이오메카닉스',
    recruiting: '대학 스카우트 & 진로 상담',
    playerRecruiting: '프로 스카우트 & 쇼케이스',
    parentRecruiting: '대학 스카우트 & 진로 센터',
    lineup: '선발 라인업 & 수비 배치',
    liveGame: '라이브 스코어 & 투구수',
    events: '일정 및 출석 관리',
    billing: '결제 및 서비스 구독 (Stripe)',
    settings: '조직 설정',
    management: '관리 메뉴',
    adminMenu: '팀 관리자 업무',
    coachMenu: '코치 전용 메뉴',
    playerMenu: '선수 공간',
    parentMenu: '학부모 포털',
    activeContext: '현재 조직 컨텍스트',
    switchRole: '역할 관점 전환:',
    switchPerspective: '관점 변경하기',
    signOut: '로그아웃 (Clerk)',
    createJoinOrg: '조직 생성 / 참여',
    clerkOrgs: '소속 조직 목록 (테넌트)',
    notifications: '알림',
    playerHub: '선수 마이페이지',
    playerRoster: '팀 로스터',
    playerLineup: '경기 라인업 카드',
    playerSchedule: '일정 및 참석 응답',
    playerBilling: '회비 납부 & Stripe 결제',
    parentHub: '학부모 홈',
    parentDirectory: '팀 명단 & 연락망',
    parentLogistics: '일정 및 픽업 안내',
    parentLineup: '경기 오더 확인',
    parentBilling: '회비 및 옵션 결제',
  },
  tenantReg: {
    pageTitle: '야구 구단 및 조직 등록',
    pageSubtitle: 'Clerk 기반 멀티 테넌트 구단을 등록하고 관리자 계정과 조직 ID를 API 서버에 자동 연동합니다.',
    step1Label: '1. 테넌트 관리자 계정 생성',
    step2Label: '2. 야구 구단 조직 설정',
    managerTip: '구단 전체의 선수 명단, 결제 구독, 설정을 총괄하는 대표 관리자 (Org Admin) 계정을 생성합니다.',
    fullName: '관리자 성명',
    workEmail: '업무용 이메일 (Clerk 로그인 ID)',
    phoneOptional: '연락처 (선택)',
    password: '비밀번호',
    alreadyHaveAccount: '이미 계정이 있으신가요? 로그인하기',
    continueToOrg: '구단 조직 설정으로 이동',
    orgTip: '야구 구단의 기본 정보를 설정합니다. 발급된 Clerk Organization ID는 백엔드 API 서버에 자동 전송됩니다.',
    orgNameLabel: '야구 조직 / 구단명',
    typeLabel: '테넌트 구분 (Tenant Type)',
    tierLabel: '테넌트 구분',
    types: {
      PRO: '프로 (Pro)',
      AMATEUR: '사회인/클럽 (Amateur)',
      ACADEMIC: '학원/학교 (Academic)',
      OTHERS: '기타 (Others)',
    },
    orgSlugLabel: '조직 고유 식별자 (Slug / Clerk ID)',
    apiSyncNotice: 'userId 및 orgId를 API 서버에 자동 연동',
    backToManager: '관리자 정보로 돌아가기',
    createAndLaunch: '구단 등록 및 워크스페이스 시작',
    successTitle: '조직 등록 완료!',
    successMsg: '{org} (관리자: {user}) 구단이 생성되었으며 백엔드 API와 연동되었습니다.',
    sportTypeLabel: '종목 (Sport Type)',
    seasonYearLabel: '시즌 연도',
    enterCodeLabel: '6자리 인증 코드 입력',
    resendCode: '인증 코드 재발송',
    resendingCode: '코드 재발송 중...',
    verifyContinue: '인증 완료 및 계속하기',
    editEmail: '이메일 수정',
    autoFillSocial: '소셜 계정으로 자동 입력:',
    orEnterCredentials: '또는 직접 이메일 입력',
    clerkModalBtn: 'Clerk 모달 화면',
    passwordPolicyNote: 'Clerk 보안 정책에 따라 비밀번호는 15자 이상이어야 합니다',
    nativeScopingBadge: '자체 DB 멀티 테넌시 스코핑',
    selectedBadge: '선택됨',
  },
  master: {
    title: '리그 팀 및 선수 마스터 관리',
    badge: '마스터 DB',
    subtitle: '{name}의 참가 리그 소속 팀 등록, 자팀/상대팀 설정 및 선수 마스터와 테넌트 유저 계정 연동을 관리합니다.',
    ownTeamsCount: '우리 구단 {count}팀',
    opponentsCount: '상대팀 {count}팀',
    leagueTeamsTab: '리그 팀 마스터 ({count})',
    playerMasterTab: '선수 마스터 & 유저 계정 연동 ({count})',
    searchTeamsPlaceholder: '마스터 내 팀 이름 또는 리그로 검색...',
    addMasterTeam: '마스터 팀 추가',
    colTeamName: '팀 이름',
    colLeague: '참가 리그 / 대회',
    colDivision: '디비전 / 부문',
    colCoach: '감독 / 헤드코치',
    colDesignation: '소속 구분',
    colActions: '관리',
    ownClub: '우리 구단 (자팀)',
    opponent: '리그 상대팀',
    manageRoster: '로스터 관리',
    scouted: '상대팀',
    searchPlayersPlaceholder: '선수 이름, 등번호, 이메일로 검색...',
    allTeamsFilter: '마스터 전체 팀',
    colJersey: '#',
    colPlayerName: '선수 마스터 이름',
    colPrimaryTeam: '소속 팀',
    colPosition: '포지션',
    colLinkedUser: '연동 테넌트 유저',
    colAccountStatus: '계정 상태',
    colUserLinkage: '유저 연동',
    notLinked: '유저 미연동',
    inviteSentText: '초대 발송됨: {email}',
    linkUserBtn: '유저 연동',
    unlinkBtn: '연동 해제',
    sendInviteTitle: '초대 이메일 발송',
    unlinkTitle: '유저 계정 연동 해제',
    linkModalTitle: '선수 마스터와 테넌트 유저 계정 연동',
    linkModalEmailLabel: '테넌트 유저 계정 이메일 (Clerk 로그인 ID)',
    linkModalEmailDesc: '해당 유저가 Clerk으로 로그인하면 자동으로 이 선수의 로스터, 기록, 라인업 카드에 연결됩니다.',
    linkModalSubmit: '계정 연동하기',
    addTeamModalTitle: '리그 마스터 팀 등록',
    addTeamModalNameLabel: '팀 이름',
    addTeamModalNamePlaceholder: '예: 베이 에어리어 밤버즈 18U',
    addTeamModalLeagueLabel: '참가 리그 이름',
    addTeamModalLeaguePlaceholder: '예: 프리미어 쇼케이스 서킷',
    addTeamModalDivisionLabel: '디비전',
    addTeamModalDivisionPlaceholder: '예: 바시티 프리미어',
    addTeamModalCoachLabel: '감독 이름',
    addTeamModalCoachPlaceholder: '예: 릭 산타나 감독',
    addTeamModalDesignationLabel: '소속 구분',
    addTeamModalOwnOption: '우리 구단 / 소속 팀 (자팀)',
    addTeamModalOpponentOption: '리그 상대팀',
    addTeamModalSubmit: '마스터 팀 저장',
    markedOwnTeam: '자팀으로 설정 완료',
    markedOpponent: '리그 상대팀으로 설정 완료',
    markedDesc: '{name} 팀이 {role}으로 지정되었습니다.',
    userLinked: '테넌트 유저 계정 연동 완료',
    userLinkedMsg: '선수 #{num} {name}을 Clerk 계정({email})에 성공적으로 연동했습니다.',
    userUnlinked: '유저 계정 연동 해제 완료',
    userUnlinkedMsg: '#{num} {name}의 계정 연동이 해제되었습니다.',
    inviteDispatched: '초대장 발송 완료',
    inviteDispatchedMsg: '{target}으로 테넌트 온보딩 초대장이 발송되었습니다.',
    teamRegistered: '마스터 팀 등록 완료',
    teamRegisteredMsg: '{team}이 {league} 리그에 등록되었습니다.',
  },
  roles: {
    admin: '팀 관리자 (엘레나)',
    coach: '감독 / 관리자',
    player: '선수 (콜 #24)',
    parent: '학부모 (보호자)',
    ADMIN: '조직 관리자',
    COACH: '감독 / 코치',
    GUARDIAN: '학부모 / 보호자',
    TEAM_ADMIN: '팀 관리자',
    HEAD_COACH: '감독 / 헤드코치',
    ORG_ADMIN: '조직 관리자',
    PLAYER: '선수',
    PARENT: '학부모',
  },
  videoAnalytics: {
    title: '비디오 분석 & 4K AI 텔레스트레이션',
    subtitle: '{name}의 초고속 투구 궤적 분석, 타구 속도 및 스트라이크 존 판독',
    bookmarked: '영상 보관 완료',
    bookmarkedMsg: '{title} 영상을 하이라이트에 저장했습니다.',
  },
  training: {
    title: '스킬 트레이닝 & 바이오메카닉스 센터',
    subtitle: '{name}의 구속 향상 프로그램, 주간 숙제 드릴 및 투구/타격 폼 분석',
    weeklyProgramTitle: '4주차 집중 육성 프로그램',
    weekProgress: '이번 주 숙제 달성률',
    assignedDrills: '배정된 숙제 & 훈련 드릴',
    done: '완료됨',
    uploadDrillVideo: '훈련 영상 과제 제출',
    drillCompleted: '훈련 드릴 완료 체크!',
    homeworkUploaded: '영상 과제 업로드 완료',
    homeworkUploadedMsg: '훈련 영상이 코칭스태프에게 전송되었습니다.',
  },
  billing: {
    teamAdminTitle: '팀 결제 관리 & 서비스 구독',
    teamAdminSubtitle: '{name}의 결제 유형(팀 일괄 / 개별 분담) 및 Stripe 서비스 구독 관리',
    memberTitle: '회비 납부 및 플랜 관리',
    memberSubtitle: '시즌 회비, 개별 스킬 트레이닝 Stripe 결제 및 영수증 내역',
    managingTeam: '관리 팀 선택:',
    paymentModelTitle: '팀 결제 모델 설정',
    paymentModelDesc: '팀 서비스 비용을 구단이 일괄 결제할지, 선수/보호자에게 개별 청구할지 선택합니다.',
    teamPayment: '팀 일괄 결제 (구단 일괄 청구)',
    teamPaymentDesc: '모든 서비스 및 회비를 구단 대표 Stripe 카드로 일괄 청구합니다.',
    individualPayment: '개별 분담 결제 (선수/보호자 청구)',
    individualPaymentDesc: '선수 및 보호자에게 개별 Stripe 청구서와 결제 링크가 전송됩니다.',
    singleStripeInvoice: '구단 대표 카드 월간 통합 청구',
    athleteGuardianInvoices: '선수/보호자가 포털에서 직접 결제',
    paymentTypeUpdated: '결제 모델이 업데이트되었습니다',
    paymentTypeUpdatedMsg: '{team} 결제 유형이 {type}로 변경되었습니다.',
    servicesCatalog: '팀 서비스 구독 목록',
    servicesCatalogSubtitle: '비디오 분석 AI, 바이오메카닉스 훈련, 스카우팅 홍보 기능을 팀에 도입합니다.',
    videoAnalyticsRule: '비디오 분석 서비스는 팀 전체 공용 인프라로 ‘팀 일괄 결제’만 지원합니다.',
    videoAnalyticsRuleNote: '{name} 서비스가 팀 일괄 결제로 활성화되었습니다.',
    teamOnlyBilling: '팀 일괄 결제만 가능',
    supportsBilling: '{type} 지원',
    includedCore: '기본 플랫폼 (활성)',
    manageCancel: '구독 관리 / 취소',
    subscribeStripe: 'Stripe로 구독 시작',
    serviceSubscribed: '서비스가 구독되었습니다',
    serviceSubscribedMsg: '{name} 서비스가 팀에 활성화되었습니다.',
    serviceCanceled: '구독이 정지되었습니다',
    serviceCanceledMsg: '{name} 서비스는 이번 결제 기간 종료 시 비활성화됩니다.',
    coreRequired: '필수 기본 기능',
    coreRequiredMsg: 'Baseball Cloud Core는 선수 명단과 일정 관리를 위한 필수 모듈입니다.',
    memberDuesPortal: '선수 계정 및 회비 납부',
    goodStanding: '회비 완납 (정상 상태)',
    enrolledWith: '{team} 소속 등록 완료 ({org})',
    seasonDues: '2025 시즌 선수 회비',
    individualAddons: '선수 개인 맞춤형 옵션',
    skillTrainingTitle: '스킬 트레이닝 & 바이오메카닉스',
    skillTrainingAthleteDesc: '구속 향상 맞춤 프로그램, 타격 훈련 숙제 영상, 코치 1:1 상담 채팅.',
    updatePaymentMethod: '카드 정보 변경 (Stripe)',
    changePaymentMethod: '결제 수단 변경 / 선택',
    selectPaymentMethod: '결제 수단 선택',
    choosePaymentMethodPrompt: '서비스 구독을 활성화하기 위해 구단 결제 수단(신용카드, 계좌이체, 편의점 결제)을 선택하세요.',
    payWithCard: '신용카드 (Stripe)',
    payWithCardDesc: 'Visa, Mastercard, AMEX 등으로 즉시 자동 결제.',
    payWithBank: '가상계좌 이체 (Bank Transfer / 振込)',
    payWithBankDesc: '전용 가상계좌로 자동 정산 및 무통장 입금.',
    payWithKonbini: '편의점 결제 (Konbini)',
    payWithKonbiniDesc: '세븐일레븐, 로손, 패밀리마트 등 편의점 현금 수납.',
    manageInStripePortal: 'Stripe 고객 포털에서 관리',
    openStripePortal: 'Stripe 고객 포털',
    paymentMethodTitle: '대표 마스터 결제 수단 (구단 관리자)',
    paymentMethodSubtitle: '팀 전체 서비스 구독, 자동 갱신 및 옵션 기능 결제에 사용되는 등록 결제 수단입니다.',
    noCardOnFile: '결제 수단이 등록되지 않았습니다. 신용카드, 가상계좌 또는 편의점 결제를 선택하세요.',
    cardOnRecord: '등록된 결제 카드',
    defaultMethod: '기본 결제 수단',
    activeSubscriptionsTitle: '활성 구단 구독 현황',
    activeSubscriptionsSubtitle: '구단 Stripe 계정에 연동되어 현재 활성화된 서비스 구독 목록입니다.',
    noActiveSubs: '현재 활성화된 구독이 없습니다. 아래 카탈로그에서 플랜을 선택하세요.',
    renewsOn: '갱신 예정일: {date}',
    stripeCustomerId: 'Stripe 고객 ID:',
    coveredByTeam: '팀 일괄 구독으로 전액 지원됨',
    proceedToStripe: 'Stripe 결제 진행하기',
    confirmPaymentMethod: '결제 수단 저장 및 적용',
    videoAnalyticsPlayerNote: '팀 관리자가 비디오 분석을 구독하여 전 경기 4K 투구/타격 분석을 무료로 시청할 수 있습니다.',
    accessGranted: '비디오 분석 전체 열람 권한 활성화',
    paymentHistory: '결제 및 전자 영수증 내역',
    stripeModalTitle: 'Stripe 안전 결제',
    amountDueToday: '오늘 결제할 총 금액:',
    cardholderName: '카드 소유자 이름',
    cardNumber: '카드 번호',
    expiryDate: '유효기간 (MM/YY)',
    cvc: 'CVC / CVV',
    payWithStripe: 'Stripe로 결제하기',
    paymentSuccess: '결제가 완료되었습니다!',
    paymentSuccessMsg: '{service}의 Stripe 결제가 성공적으로 처리되었습니다. 영수증이 이메일로 발송되었습니다.',
    coachRestrictionNotice: '코치 권한: 로스터, 라인업, 이벤트, 시트 할당 관리 권한을 가집니다. 플랜 업그레이드 및 결제 수단 변경은 테넌트 관리자에게 문의하세요.',
    pendingCancelBadge: '해지 대기 중 (기간 종료 시까지 이용 가능)',
    resumeBtn: '구독 재개하기',
    manageSeatsBtn: '시트 할당 관리',
    cancelTeamPlan: '팀 플랜 해지',
    subscribeTeamPlan: 'Stripe로 팀 구독 (Team)',
    monthlyDuesLabel: '월별 회비 (월간 결제 주기):',
    setupRequiredTitle: '설정 필요: Stripe 결제 수단 등록 및 서비스 활성화',
    setupRequiredDesc: 'Next Base에 오신 것을 환영합니다! 신용카드, 계좌이체, 편의점 결제를 설정하고 {org}의 운영 모듈을 활성화하세요.',
    stripeCheckoutLaunched: 'Stripe 결제 세션 시작',
    redirectingToStripe: '{service} 확인을 위해 Stripe로 이동 중입니다...',
    subscriptionActivated: '구독 활성화 완료',
    subscriptionActivatedMsg: '{org}에 {service} 구독이 성공적으로 적용되었습니다.',
    loadingStripeElements: '안전한 Stripe Elements 폼을 로드하는 중...',
    stripeSecure256: '공식 Stripe.js 보안 API',
    stripeDirect256: '공식 Stripe.js API 기반 256비트 토큰화 결제',
    customerLabel: '고객 식별자: {id}',
    paylinkGenTitle: 'Stripe 결제 링크 생성기',
    paylinkGenSubtitle: '선수 또는 학부모에게 이 URL을 공유하여 시즌 회비를 간편하게 수납하세요.',
    copyBtn: '복사',
    doneBtn: '완료',
  },
  liveGame: {
    title: '라이브 경기 기록 & Pitch Smart 투구수 관리',
    subtitle: '{name}의 실시간 볼카운트, 투구수 안전 제한 및 휴식일 자동 계산',
    topInning: '{inning}회 초',
    botInning: '{inning}회 말',
    inning: '{inning}회',
    balls: '볼 (B)',
    strikes: '스트라이크 (S)',
    outs: '아웃 (O)',
    atBat: '현재 타자:',
    onDeck: '다음 타자:',
    pitcher: '등판 투수:',
    pitchCount: '누적 투구수',
    pitchLimit: 'Pitch Smart 제한: {limit}구',
    restDaysRequired: '의무 휴식일: {days}일',
    quickPlays: '원클릭 판정 기록',
    ball: '+ 볼',
    strike: '+ 스트라이크 (헛스윙/루킹)',
    foul: '파울',
    hitSingle: '1루타 (Single)',
    hitDouble: '2루타 (Double)',
    hitTriple: '3루타 (Triple)',
    homeRun: '홈런 (HR)',
    strikeout: '삼진 (K)',
    walk: '볼넷 (BB)',
    outInPlay: '범타 아웃',
    runScored: '+ 득점 추가',
    advanceInning: '공수 교대 (다음 이닝)',
    resetCount: '볼카운트 리셋',
    gameLog: '실시간 문자 중계 로그',
    noPlaysYet: '기록이 없습니다. 상단 버튼으로 판정을 기록하세요.',
    liveScoreboard: '전광판 스코어보드',
    runnersOnBase: '루상 주자 현황',
    clearBases: '주자 일소',
    pitchRecorded: '투구수 기록 완료',
    pitchRecordedMsg: '{pitcher} 투수의 {count}번째 투구가 기록되었습니다.',
    pitchLimitWarning: 'Pitch Smart 투구수 제한 경고',
    pitchLimitWarningMsg: '{pitcher} 투수가 {count}구에 도달했습니다 (의무 휴식: {days}일).',
  },
  coachDashboard: {
    title: '구단 개요 • 감독 커맨드 센터',
    subtitle: '{name}의 실시간 구단 운영 현황',
    manageTeams: '팀 관리',
    activeTeams: '운영 팀 수',
    inSeason: '시즌 진행 중',
    activeRoster: '등록 선수 수',
    total: '명 중',
    scheduledEvents: '예정된 일정',
    next7Days: '향후 7일간',
    winRate: '구단 승률',
    upcomingGames: '예정된 경기 및 훈련',
    viewAllSchedule: '전체 일정 보기',
    clubTeams: '소속 팀 목록',
    manage: '관리',
    confirmed: '참석 확정',
    out: '불참',
    pending: '미응답',
    game: '경기',
    practice: '훈련',
    coach: '감독',
  },
  playerDashboard: {
    welcome: '돌아온 것을 환영합니다, {name} 선수!',
    battingAvg: '타율 (AVG)',
    exitVelo: '타구 속도',
    ops: '출루율+장타율 (OPS)',
    nextGame: '다음 예정 경기',
    firstPitch: '플레이볼까지 36시간',
    reportTime: '집합 시간',
    reportTimeVal: '내일 15:00 구장 집합',
    uniform: '착용 유니폼',
    location: '경기 구장',
    attendance: '나의 출석 상태:',
    confirmedIn: '참석 확정',
    declinedOut: '불참',
    imIn: '참석하기',
    cannotAttend: '불참 사유 제출',
    lineupAssignment: '나의 타순 및 수비 포지션',
    startingLineup: '선발 출장',
    batterHole: '2번 타자',
    posShortstop: '포지션: 유격수 (SS)',
    card: '오더표',
    coachBulletin: '감독 전달사항',
    coachQuote: '“화요일 불펜 피칭 세션이 아주 훌륭했습니다. 타격 훈련은 16:30 정각에 시작하니 양쪽 유니폼 상의를 모두 지참하세요.”',
    coachAuthor: '— 마커스 "스킵" 홀로웨이 감독',
    rsvpSuccess: '참석이 등록되었습니다',
    rsvpSuccessMsg: '챔피언십 경기 참석 상태로 등록되었습니다.',
    rsvpDeclined: '불참이 등록되었습니다',
    rsvpDeclinedMsg: '홀로웨이 감독님께 불참 사유가 전달되었습니다.',
  },
  parentDashboard: {
    title: '학부모 포털 • {name}',
    duesPaid: '시즌 회비: 완납',
    enrolledWith: '{team} 소속 등록 완료 ({org})',
    gameDayDest: '경기장 위치 및 이동 안내',
    round1: '제1회 쇼케이스 대회',
    complexAddress: '구장 주소:',
    dropOff: '선수 도착/픽업 시간:',
    dropOffVal: '경기 시작 90분 전 (15:00)',
    gameUniform: '착용 유니폼:',
    transportConfirmed: '이동 및 출석 확인 완료',
    athleteMarked: '보호자 확인을 통해 출석이 기록되었습니다.',
    update: '변경하기',
    headCoachContact: '감독 직통 연락처',
    medWaiver: '메디컬 및 동의서 상태',
    cleared: '승인 완료',
    waiverMsg: '2025 시즌 선수 신체검사서 및 구단 면책동의서가 정상 등록되어 있습니다.',
    rsvpSuccess: '학부모 확인이 완료되었습니다',
    rsvpSuccessMsg: '{name} 선수의 {event} 경기 픽업 및 참석 정보가 저장되었습니다.',
  },
  teams: {
    title: '팀 및 디비전 목록',
    subtitle: '{name} 소속 팀 로스터, 코칭스태프 배정 및 일정 관리',
    addNewTeam: '새 팀 생성',
    searchPlaceholder: '팀 이름, 디비전, 감독 이름으로 검색...',
    record: '승패 전적 (W-L)',
    rosterSize: '로스터 인원',
    players: '명',
    headCoach: '감독:',
    viewRoster: '로스터 보기',
    schedule: '팀 일정표',
    noTeams: '해당하는 팀이 없습니다',
    noTeamsDesc: '현재 검색 조건 또는 조직 내에 등록된 팀이 없습니다.',
    createFirstTeam: '첫 번째 팀 생성하기',
    createModalTitle: '새 야구팀 생성',
    createModalSubtitle: '{name} 조직 하위에 새 디비전 팀 등록',
    teamName: '팀 이름',
    season: '시즌',
    division: '디비전 / 소속 리그',
    teamColor: '팀 대표 색상',
    cancel: '취소',
    saveTeam: '팀 저장',
    billingLabel: '청구 모델:',
    teamMaster: '구단 일괄',
    splitDues: '개인 분할 회비',
    paymentModel: '결제 모델',
    teamMasterPayment: '구단 일괄 결제',
    individualPlayerDues: '개인별 회비 분할 결제',
    syncWithApi: 'API와 동기화',
    stripeBilling: 'Stripe 결제 관리',
    videoAnalyticsSubscribed: '비디오 분석 구독 중',
    skillTrainingSubscribed: '스킬 트레이닝 구독 중',
    createTeamFailed: '팀 생성 실패',
    teamCreatedSuccess: '{name} 팀이 생성되었습니다.',
  },
  roster: {
    backToTeams: '팀 목록으로 돌아가기',
    activeAthletes: '명의 등록 선수',
    lineupCard: '라인업 카드',
    addPlayer: '선수 추가',
    seatAllocations: '시트 할당 관리',
    searchPlaceholder: '선수 이름, 등번호, 포지션으로 검색...',
    allPositions: '전체 포지션',
    playerName: '선수 이름',
    primaryPos: '주 포지션',
    batsThrows: '투타',
    class: '졸업년도',
    status: '상태',
    actions: '관리',
    viewProfile: '프로필 보기',
    noRecords: '검색 조건과 일치하는 선수가 없습니다.',
    addModalTitle: '로스터에 선수 등록',
    addModalSubtitle: '{team} 팀에 새 선수를 등록합니다',
    firstName: '이름 (First Name)',
    lastName: '성 (Last Name)',
    jersey: '등번호',
    position: '포지션',
    emailOptional: '이메일 (선택)',
    gradYear: '졸업 예정 연도',
    addAthlete: '선수 등록',
    playerAdded: '선수 추가 완료',
    playerAddedMsg: '#{num} {first} {last} 선수가 로스터에 등록되었습니다',
  },
  playerModal: {
    title: '선수 프로필 & 스카우팅 지표',
    heightWeight: '신장 / 체중',
    exitVelocity: '타구 속도 (Exit Velo)',
    armVelocity: '송구 속도 (Arm Velo)',
    sprint60: '60야드 달리기 기록',
    availability: '출전 가능 상태',
    active: '정상 출전 가능',
    injured: '부상자 명단 (IL)',
    reserve: '리저브 / 대기',
    contacts: '선수 및 보호자 연락처',
    noEmail: '등록된 이메일 없음',
    scoutingNotes: '감독 스카우팅 메모 & 육성 방향',
    saveChanges: '변경사항 저장',
    profileSaved: '선수 정보 업데이트 완료',
    profileSavedMsg: '측정 지표 및 출전 상태가 성공적으로 저장되었습니다.',
    bats: '타석',
    throws: '투구',
    gradClass: '{year}년 졸업 예정',
  },
  lineup: {
    title: '선발 라인업 & 수비 포지션표',
    badge: '경기 준비',
    subtitle: '{name}의 9인 선발 타순 및 수비 시프트를 편성합니다',
    autoFill: '자동 최적화 편성',
    saveCard: '라인업 저장',
    battingOrder: '타격 순서 (1~9번)',
    starters: '선발 9명',
    selectBatter: '-- 타자 선택 --',
    defensivePos: '그라운드 수비 배치',
    synchronized: '동기화됨',
    cardSaved: '라인업 카드가 저장되었습니다',
    cardSavedMsg: '심판 교환용 공식 오더지가 준비되었습니다.',
    autoAssigned: '선발 라인업이 자동 편성되었습니다',
    autoAssignedMsg: '컨디션이 우수한 주전 선수들로 9인 타순을 배치했습니다.',
    clickToAssign: '그라운드의 포지션 배지를 클릭하면 선발 선수 정보를 확인할 수 있습니다.',
    shiftScheme: '수비 시프트 체계:',
    shiftStandard: '정상 수비 위치',
    shiftInfieldIn: '전진 수비 (홈 승부)',
    shiftPull: '우타자 당겨치기 시프트',
    shiftNoDoubles: '장타 경계 (깊은 수비)',
    fieldHelp: '그라운드의 포지션 배지를 클릭하면 할당된 선수와 수비 깊이를 확인할 수 있습니다.',
    printLineup: '라인업 카드 출력',
  },
  events: {
    title: '일정 및 출석 관리',
    subtitle: '{name}의 경기, 훈련 일정 및 선수 출석 점호',
    scheduleEvent: '일정 추가',
    allEvents: '전체 일정',
    gamesOnly: '공식 경기만',
    practices: '훈련 일정만',
    rollCall: '출석 점호',
    confirmed: '명 참석 확정',
    eventTitle: '일정명',
    eventType: '일정 종류',
    homeAway: '홈 / 어웨이',
    opponent: '상대팀 (경기인 경우)',
    location: '구장 / 훈련 장소',
    eventScheduled: '일정이 등록되었습니다',
    eventScheduledMsg: '{title} 일정이 캘린더에 추가되었습니다.',
    attending: '출석',
    declined: '불참',
    pending: '미정 / 대기',
    saveRollCall: '점호 결과 저장',
    game: '경기',
    practice: '훈련',
    scrimmage: '청백전 / 연습경기',
    tryout: '트라이아웃 / 입단테스트',
    home: '홈',
    away: '어웨이',
    syncSchedule: '일정 새로고침',
    scheduleEventError: '일정 등록 오류',
  },
  attendanceModal: {
    title: '이벤트 출석 & 점호 집계',
    markAllAttending: '전원 ‘출석’ 처리',
    resetAll: '초기화',
    in: '출석',
    out: '불참',
    maybe: '미정',
    saveAttendance: '점호 저장',
    cancel: '취소',
    successTitle: '출석 정보 업데이트 완료',
    successMsg: '{title} 일정의 점호 결과가 저장되었습니다.',
  },
  settings: {
    title: '조직 및 테넌트 설정',
    subtitle: '{name}의 Clerk 멀티 테넌트 연동 및 시스템 설정',
    metadata: '조직 메타데이터',
    orgName: '구단 / 클럽명',
    seasonScope: '적용 시즌 연도',
    savedMsg: '설정이 성공적으로 저장되었습니다',
    saveChanges: '변경사항 저장',
    apiClerk: 'API 및 Clerk JWT 인터셉터 연동',
    apiClerkDesc: 'Axios가 자동으로 Clerk 인증 토큰 및 X-Tenant-Id 테넌트 헤더를 전송합니다.',
    tabConfig: '테넌트 기본 설정',
    tabMembers: '멤버 관리 및 초대',
    tabApi: 'API 스코핑 & 헤더',
    membersTitle: '테넌트 멤버 및 역할 관리 (RBAC)',
    membersSubtitle: '역할 권한 (ADMIN, COACH, PLAYER, GUARDIAN) 관리 및 마지막 관리자 보호 가드레일.',
    lastAdminNotice: '마지막 관리자 가드레일 작동 중: 최소 1명 이상의 관리자가 필요합니다. 활성 관리자: {count}명',
    softDeletionMode: '소프트 삭제 / 권한 회수 모드',
    colMemberName: '멤버 성명',
    colEmail: '이메일',
    colAssignedTeam: '소속 팀',
    colRole: '역할 (RBAC)',
    colAccess: '접근 권한 관리',
    unassigned: '팀 미지정',
    lastAdminBadge: '마지막 관리자',
    lastAdminTooltip: '역할 변경 불가: 구단에는 최소 1명 이상의 활성 관리자가 유지되어야 합니다.',
    revokeTooltip: '권한 회수 불가: 마지막 관리자의 접근 권한을 회수할 수 없습니다.',
    revokeBtn: '테넌트 권한 회수',
    revokeConfirm: '{name}의 접근 권한을 회수하시겠습니까? 할당된 서비스 시트는 풀로 반환됩니다.',
    apiScopingTitle: '자체 데이터베이스 멀티 테넌시 스코핑',
    apiScopingSubtitle: '모든 백엔드 API 요청 헤더에 첨부 (/api/v1/...)',
    apiScopingDesc: '사용자 신원 인증은 Clerk JWT를 통해 처리되며, 조직 멤버십과 권한은 PostgreSQL 모델을 기반으로 격리 검증됩니다.',
    classificationTier: '분류 티어 (Tier)',
    sportType: '종목 (Sport Type)',
    seasonYear: '시즌 연도',
  },
  seatAllocation: {
    modalTitle: '서비스 시트(라이선스) 할당',
    modalSubtitle: '{service}의 계약된 사용자 시트를 선수와 코칭스태프에게 할당합니다.',
    utilization: '시트 이용률:',
    seatsContracted: '{count}석 계약됨',
    available: '{count}석 이용 가능',
    assignSectionTitle: '팀 멤버에게 시트 할당',
    selectPlaceholder: '할당할 선수 또는 스태프를 선택하세요...',
    assignBtn: '시트 할당',
    capacityFullWarning: '계약 시트 한도 초과 ({total}/{total}). 플랜을 업그레이드하거나 미사용 시트를 해제하세요.',
    activeMembersTitle: '할당된 활성 멤버 ({count}명)',
    searchPlaceholder: '할당된 멤버 검색...',
    colMember: '멤버',
    colRoleJersey: '역할 / 등번호',
    colAssignedDate: '할당 일자',
    colAction: '관리',
    noAssigned: '현재 이 서비스에 할당된 멤버가 없습니다.',
    unassignBtn: '할당 해제',
    unassignConfirm: '{name}의 시트 할당을 해제하시겠습니까? 시트는 잔여 풀로 반환됩니다.',
    ledgerBadge: 'PostgreSQL 실시간 시트 원장',
    close: '닫기',
    assignedSuccess: '서비스 시트가 성공적으로 할당되었습니다',
    unassignedSuccess: '{name}의 시트 할당이 해제되었습니다',
    noServiceAssigned: '서비스가 할당되지 않았습니다',
  },
  capacityExceeded: {
    title: '시트 계약 용량 초과',
    badge: '409 Conflict',
    defaultMsg: '계약된 시트 수량을 초과하는 할당 요청입니다.',
    contractedSeats: '계약된 시트:',
    currentlyAllocated: '현재 할당됨:',
    requestedAdditional: '추가 요청:',
    overage: '초과 수량:',
    seatsNeeded: '+{count}석 추가 계약 필요',
    coachNotice: '코치 권한으로는 플랜을 직접 업그레이드할 수 없습니다. 테넌트 관리자에게 시트 추가 확장을 요청하세요.',
    cancelBtn: '취소',
    upgradeBtn: '플랜 업그레이드',
  },
  invoices: {
    title: '청구서 및 결제 내역',
    subtitle: 'PDF 세금계산서/영수증 다운로드 및 구단 일괄 결제, 개인 회비 정산 상태를 확인하세요.',
    refreshBtn: '내역 새로고침',
    tabTenant: '구단 일괄 청구',
    tabIndividual: '개인별 청구',
    colInvoiceNum: '청구서 번호',
    colDate: '청구일',
    colDescription: '내역',
    colBilledOrg: '청구 조직',
    colAthletePayer: '선수 / 납부자',
    colService: '서비스',
    colAmount: '금액',
    colStatus: '상태',
    colDownload: '영수증',
    noTenantInvoices: '구단 결제 청구서가 없습니다.',
    noIndividualInvoices: '개인 결제 청구 내역이 없습니다.',
    pdfBtn: 'PDF',
  },
  memberInvite: {
    drawerTitle: '팀 멤버 초대',
    infoTip: '초대된 멤버는 안내 이메일을 받아 자체 테넌트 범위 내에서 계정을 생성하고 참여할 수 있습니다.',
    emailLabel: '초대할 이메일 주소',
    emailPlaceholder: "예: coach.smith{'@'}example.com",
    roleLabel: '부여할 역할 (RBAC)',
    teamLabel: '소속 팀 지정 (선택)',
    teamPlaceholder: '소속 팀을 선택하세요...',
    rolePermissions: '역할별 권한 안내:',
    adminDesc: '구단 설정, 멤버 관리, 초대, 구독 결제, Stripe 포털, 시트 할당 등 전체 권한.',
    coachDesc: '로스터, 라인업, 경기/훈련 일정, 시트 할당 관리. (구독 플랜 및 결제수단 변경 불가).',
    playerDesc: '개인 일정 확인, 출결 응답, 프로필, 개인 회비/구독 결제.',
    guardianDesc: '선수 일정 확인, 출결 응답, 프로필, 개인 회비/구독 결제.',
    cancelBtn: '취소',
    sendBtn: '초대장 발송',
    successMsg: '{email}님에게 초대 이메일을 발송했습니다',
    invalidEmail: '올바른 이메일 주소를 입력해 주세요.',
  },
  common: {
    home: '홈',
    away: '어웨이',
    active: '출전 가능',
    injured: '부상 (IL)',
    reserve: '리저브',
    cancel: '취소',
    save: '저장',
    sync: '동기화',
    refresh: '새로고침',
    close: '닫기',
    delete: '삭제',
    edit: '수정',
    loading: '로딩 중...',
    actions: '관리',
  },
  auth: {
    signInTitle: 'Next Base 로그인',
    signInSubtitle: '멀티 테넌트 야구 운영 허브에 접속하세요',
    clerkAuth: 'Clerk 인증:',
    apiTarget: 'API 대상:',
    clientTrustTitle: 'Clerk 봇 & 기기 신뢰성 검증',
    clientTrustDesc: 'Clerk 보안 정책(Cloudflare Turnstile)에 따른 대화형 인증이 필요합니다. 검증이 완료되면 자동으로 로그인됩니다.',
    dialogNotShowing: '인증 대화상자가 보이지 않나요?',
    openVerificationModal: 'Clerk 인증 모달 열기',
    authNotice: '인증 안내',
    registerNewAccount: '새 조직 등록하기 →',
    emailLabel: '이메일 주소',
    emailPlaceholder: "coach{'@'}diamondacademy.com",
    passwordLabel: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    signInBtn: '로그인',
    clerkModalBtn: 'Clerk 모달 화면',
    registerNewOrg: '새 야구 조직 등록',
    authComplete: '인증 완료',
    welcomeBack: '{name}님, 환영합니다!',
    missingCreds: '로그인 정보 부족',
    missingCredsMsg: '로그인을 위해 이메일 주소와 비밀번호를 모두 입력해 주세요.',
    authenticating: '인증 중',
    connectingToClerk: '{email} 계정의 Clerk 인증에 연결하는 중...',
    verificationRequired: '인증 필요',
    verificationChallenge: '인증 창에서 기기 신뢰성 확인을 완료해 주세요.',
    authFailed: '인증 실패',
    couldNotSignIn: '입력하신 정보로 로그인할 수 없습니다.',
    authSuccess: '인증 성공',
    subRequired: '구독 필요',
    subRequiredMsg: '운영 기능을 이용하시려면 팀 구독 플랜을 활성화하세요.',
    orContinueWith: '또는 소셜 계정으로 로그인',
    orSignUpWith: '또는 소셜 계정으로 가입',
  },
  onboarding: {
    joinedOrgTitle: '소속된 구단 / 조직',
    joinedOrgSubtitle: '인증된 테넌트 구단 워크스페이스에 연결되었습니다.',
    orgType: '{type} 구단',
    enterWorkspace: '구단 워크스페이스 입장',
    registerNewOrg: '새 야구 조직 등록하기',
  },
  lineupCard: {
    modalTitle: '공식 심판 제출용 라인업 카드',
    headerBadge: '공식 타순 & 수비 오더지',
    division: '소속 디비전',
    headCoach: '감독',
    date: '일자',
    verified: '검증 완료',
    num: '등번호',
    pos: '수비',
    managerSig: '감독 서명',
    umpireSig: '주심 서명',
    printBtn: '라인업 카드 인쇄',
  },
  recruitingHub: {
    title: 'NCAA & 프로 쇼케이스 스카우트 센터',
    verifiedBadge: 'NCAA 공인 검증',
    subtitle: '{name} 선수의 스카우트 패킷, 공인 레이더 측정 리더보드 및 진로 파이프라인',
    commitsBadge: '{count}명 진학 확정 (D1/D2)',
    topExitVelo: '최고 공인 타구속도',
    fastest60: '최속 60야드 달리기',
    avgGpa: '선수단 평균 GPA (학점)',
    searchPlaceholder: '선수명, 학교, 포지션 검색...',
    allGradClasses: '전체 졸업 기수',
    class2025: '2025년 졸업 (고3)',
    class2026: '2026년 졸업 (고2)',
    class2027: '2027년 졸업 (고1)',
    allStatuses: '전체 진로 상태',
    uncommittedOnly: '미확정 선수만',
    committedOnly: '진학 확정',
    colProspect: '선수명',
    colClass: '기수',
    colExitVelo: '타구속도',
    colArmVelo: '송구속도',
    colSixty: '60야드',
    colGpa: 'GPA',
    colStatusSchool: '진로 상태 & 학교',
    colScoutPacket: '스카우트 패킷',
    uncommittedTag: '미확정',
    copyLinkTitle: '공인 스카우터 링크 복사',
    downloadPdfTitle: '1페이지 PDF 프로필 다운로드',
    dossierTitle: '공인 대학 스카우팅 리포트',
    peakExitVelo: '최고 타구속도',
    infieldArmVelo: '내야 송구속도',
    sixtyYardDash: '60야드 달리기',
    heightWeight: '신장 / 체중',
    recruitingPipeline: '관심 대학 진로 파이프라인',
    copyRecruiterLink: '스카우터 링크 복사',
    downloadPdfPacket: 'PDF 리포트 다운로드',
    scoutLinkCopied: '스카우트 링크 복사 완료',
    scoutLinkCopiedMsg: '{name} 선수의 NCAA 스카우터 전용 링크가 복사되었습니다',
    generatingScoutPacket: '스카우트 패킷 생성 중',
    generatingScoutPacketMsg: '#{num} {name} 선수의 TrackMan 측정치 및 4K 영상 리포트를 작성하는 중...',
  }
};